import { render, staticRenderFns } from "./TableDetails.vue?vue&type=template&id=44eb3d0c&"
import script from "./TableDetails.vue?vue&type=script&lang=js&"
export * from "./TableDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports